import React from "react";
import { formatNumber } from "helpers/common";

const ACCENT_COLORS = {
  blue: "#378ADD",
  green: "#639922",
  teal: "#0F6E56",
  amber: "#BA7517",
  red: "#A32D2D",
  purple: "#534AB7",
  coral: "#D85A30",
};

/**
 * StatCard
 * @param {string}          label   - Card heading
 * @param {number|string}   value   - Numeric value (run through formatNumber)
 * @param {string}          sub     - Small description below the value
 * @param {string}          accent  - Color key: blue | green | teal | amber | red | purple | coral
 */
const StatCard = ({ label, value, sub, accent = "blue" }) => {
  const borderColor = ACCENT_COLORS[accent] ?? ACCENT_COLORS.blue;

  return (
    <div
      style={{
        background: "var(--bs-light, #f8f9fa)",
        borderRadius: 8,
        padding: "14px 16px",
        borderLeft: `3px solid ${borderColor}`,
      }}
    >
      <p style={{ fontSize: 12, color: "#6c757d", margin: "0 0 6px" }}>
        {label}
      </p>
      <p style={{ fontSize: 22, fontWeight: 500, margin: 0, color: "#212529" }}>
        {value !== undefined && value !== null ? formatNumber(value) : "—"}
      </p>
      {sub && (
        <p style={{ fontSize: 11, color: "#adb5bd", margin: "4px 0 0" }}>
          {sub}
        </p>
      )}
    </div>
  );
};

export default StatCard;
